<div class="top-loader" *ngIf="loading"></div>
<div>
    <div class="fs-4 fw-semibold mb-3">{{ 'tableofbenefit' | translate }}</div>
    <div class="row mb-4">
        <div class="col-md-6 col-lg-4 mb-2">
            <div class="d-flex align-items-center search gap-2 w-100">
                <input 
                #searchInput
                    pInputText 
                    id="search-card" 
                    [(ngModel)]="assuredID" 
                    [ngClass]="{'input-error': noDataAvailable}"
                    [placeholder]="'searchassuredid' | translate"
                />
                <button class="btn searchBtn" (click)="fetchTOBData(pageNumber, pageSize)">
                    <i *ngIf="!loading" class="pi pi-search"></i>
                    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
                </button>
            </div>
        </div>
    </div>

    <div class="row mt-4" *ngIf="medicalServices.length > 0">
        <div class="col-md-12">
            <div class="card border-0 p-3">
                <p-table 
                [value]="medicalServices"
                [lazy]="true"
                [paginator]="true"
                [rows]="pageSize"
                [totalRecords]="totalRecords"
                [rowsPerPageOptions]="[10, 50, 100]"
                [responsiveLayout]="'scroll'"
                [tableStyle]="{'min-width': '60rem'}"
                [(first)]="first"
                (onLazyLoad)="onLazyLoad($event)"
                [loading]="loading">
                    
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{ 'sr' | translate }}</th>
                            <th>{{ 'medicalservice' | translate }}</th>
                            <th>{{ 'coinsurance' | translate }}</th>
                            <th>{{ 'limit' | translate }}</th>
                            <th>{{ 'servicestartdate' | translate }}</th>
                            <th>{{ 'nooftimesallowed' | translate }}</th>
                            <th>{{ 'notallowed' | translate }}</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-service>
                        <tr>
                            <td>{{ service.srNo }}</td>
                            <td>{{ service.accountName }}</td>
                            <td>{{ service.coInsurance }}</td>
                            <td>{{ service.limit }}</td>
                            <td>{{ service.startDate }}</td>
                            <td>{{ service.times }}</td>
                            <td>{{ service.notAllowed }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
<div *ngIf="medicalServices.length === 0" class="d-flex justify-content-center align-items-center">
    <img src="../../assets/nodataavailable.png" alt="">
</div>